export const contactsData = {
    email: 'shaheedulaslam061@gmail.com',
    phone: '+91 7736314029',
    address: 'Eranikkal(h),Machingal,Melmuri[PO],676517,Malappuram,KERALA ',
    github: 'https://github.com/shaheedulaslam',
    facebook: 'https://www.facebook.com/shaheedulaslam',
    linkedIn: 'https://www.linkedin.com/in/ShaheedulAslam/',
    twitter: 'https://twitter.com/ShaheedulAslam',
    medium: 'https://medium.com/@shaheedulaslam061',
    stackOverflow: 'https://stackoverflow.com/users/21635595/shaheedul-aslam',
    devUsername: "shaheedulaslam"
}